<div class="dispatcher-video-training">
  <div class="heading">
    Training Videos
  </div>
  <ng-container *saAllowedAccountRoles="['admin', 'dispatcher']">
    <div class="videos">
      <h2>1. Well Setup & Planning Tutorial</h2>
      <section>
        <h3>
          (1 of 4) How to Create a Well
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366278126"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (2 of 4) How to Add Trucking Contracts
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366278630"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (3 of 4) How to Create and Manage Purchase Orders
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366278822"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (4 of 4) How to Create a Zipper Stage Design (If Applicable)
        </h3>
        <iframe
          src="https://player.vimeo.com/video/365330207"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
    </div>
    <div class="videos">
      <h2>2. Daily Operations Tutorial</h2>
      <section>
        <h3>
          (1 of 3) How to Order Trucks and Edit Load Details
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366279134"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (2 of 3) How to Update Stages and Current Stock
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366279288"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (3 of 3) How to Manage the Frac Dashboard
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366279398"
          width="640"
          height="351"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
    </div>
    <div class="videos">
      <h2>3. AutoPilot Tutorial</h2>
      <section>
        <h3>
          (1 of 3) How to Turn on Auto and AutoPilot Warning Email
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366279546"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (2 of 3) How AutoOrder Works
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366279658"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (3 of 3) How Up For Grabs Works
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366279728"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
    </div>
    <div class="videos">
      <h2>4. User Management Tutorial</h2>
      <section>
        <h3>
          (1 of 1) How to Create and Manage Users
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366279902"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
    </div>
    <div class="videos">
      <h2>5. Billing</h2>
      <section>
        <h3>
          (1 of 4) How to Approve a Ticket (Waiting for Ticket Approval)
        </h3>
        <iframe
          src="https://player.vimeo.com/video/394254922"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (2 of 4) How to Reject a Ticket (Waiting for Ticket Approval)
        </h3>
        <iframe
          src="https://player.vimeo.com/video/394255519"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (3 of 4) How to Approve an Invoice (Waiting for Invoice Approval)
        </h3>
        <iframe
          src="https://player.vimeo.com/video/394280022"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (4 of 4) How to Reject an Invoice (Waiting for Invoice Approval)
        </h3>
        <iframe
          src="https://player.vimeo.com/video/394256413"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
    </div>
    <div class="videos">
      <h2>6. AutoProcurement</h2>
      <section>
        <h3>
          (1 of 1) How to use AutoProcurement
        </h3>
        <iframe
          src="https://player.vimeo.com/video/415675877"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
    </div>
    <div class="videos">
      <h2>7. AutoAllocation</h2>
      <section>
        <h3>
          (1 of 1) How to use AutoAllocation
        </h3>
        <iframe
          src="https://player.vimeo.com/video/415676547"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
    </div>
  </ng-container>
  <ng-container *saAllowedAccountRoles="['default', 'sandCoordinator']">
    <div class="videos">
      <h2>1. Daily Operations Tutorial</h2>
      <section>
        <h3>
          (1 of 2) How to Order Trucks and Edit Load Details
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366279134"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (2 of 2) How to Update Stages and Current Stock
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366279288"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
    </div>
    <div class="videos">
      <h2>2. AutoPilot Tutorial</h2>
      <section>
        <h3>
          (1 of 3) How to Turn on Auto and AutoPilot Warning Email
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366279546"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (2 of 3) How AutoOrder Works
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366279658"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
      <section>
        <h3>
          (3 of 3) How Up For Grabs Works
        </h3>
        <iframe
          src="https://player.vimeo.com/video/366279728"
          width="640"
          height="344"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </section>
    </div>
  </ng-container>
</div>
